module.exports = __webpack_public_path__ + "static/img/12.c6cdba7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/sp/12.png
// module id = zIJo
// module chunks = 0